import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { SelectTeamComponent } from '../../../../my-teams/select-team/select-team.component';
import { TieService } from '../../../../_core/services/tie.service';
import { ToastService } from '../../../../_core/services/toast.service';
import { Tie } from '../../../../_shared/models/tie.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-select-tie-team',
    templateUrl: './select-tie-team.component.html',
    styleUrls: ['./select-tie-team.component.scss'],
    standalone: true,
    imports: [
        IonicModule,
        TranslateModule
    ]
})
export class SelectTieTeamComponent implements OnDestroy {
    @Input() tie: Tie;
    @Input() sideNumber: number;
    @Output() updateTie = new EventEmitter<Tie>();
    isLoading = false;
    private destroyed$: Subject<void> = new Subject();

    constructor(
        private tieService: TieService,
        private modalController: ModalController,
        private toast: ToastService
    ) { }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    async addTeam() {
        const team = (await this.selectTeam());

        if (!team) return;

        this.isLoading = true;
        this.tieService
            .addTeamToTie(this.tie._id, team._id, this.sideNumber)
            .pipe(
                takeUntil(this.destroyed$),
                finalize(() => this.isLoading = false)
            )
            .subscribe(
                res => {
                    this.tie = res.data;
                    this.updateTie.emit(this.tie);
                    this.toast.presentToast(res.message);
                },
                err => {
                    //console.log(err);
                }
            );

    }

    async selectTeam() {
        const modal = await this.modalController.create({
            component: SelectTeamComponent
        });

        await modal.present();

        const { data } = await modal.onDidDismiss();

        return data;

    }




}
